import { CommunicationOptions } from "@fluentui/react-teams";
import axios from "axios";
import InteractionRequired from "components/organisms/InteractionRequired";
import ReactTeamsCommunication from "components/organisms/ReactTeamsCommunication";
import { getWwwAuthHeader, isInteractionRequiredError } from "libs/auth";
import { getErrorsCause } from "libs/error";
import { TranslationKey } from "libs/locale/i18nLanguages";
import { FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";

function handleInteraction(target: string) {
  switch (target) {
    case "refresh":
      // window.location.reload(); 으로 새로고침 시도시 에러가 발생한 url 그대로 새로고침되어
      // 계속 에러가 발생한 queryString으로 돌아오므로
      // queryString을 제거하여 새로고침하도록 합니다.
      window.location.href = window.location.href.split("?")[0];
      break;
  }
}

export default function ErrorFallback({ error }: FallbackProps) {
  // Error type이 온다고 타입 정의가 되어있지만 "handleError()" 에서 Error 이외의 값을 던질 수 있으므로 방어적으로 대처합니다.
  if (!(error instanceof Error)) {
    error = new Error(error);
  }

  const { t } = useTranslation();
  const errorsCause = getErrorsCause(error);
  const errorsMessage = (() => {
    if (axios.isAxiosError(errorsCause)) {
      return (errorsCause.message + "\n" + JSON.stringify(errorsCause.response?.data));
    } else {
      return error.message ?? "에러 메시지가 존재하지 않습니다.";
    }
  })();

  // TODO: TTI 측정 기능 재검토
  // useEffect(() => {
  //   stopTTI();
  // }, []);

  if (isInteractionRequiredError(errorsCause)) {
    const wwwAuthHeader = getWwwAuthHeader(errorsCause.response!);
    return <InteractionRequired {...wwwAuthHeader} />;
  }

  return (
    <ReactTeamsCommunication
      option={CommunicationOptions.Error}
      fields={{
        title: t(TranslationKey["앗, 이런!"]),
        desc: errorsMessage,
        actions: {
          primary: {
            label: t(TranslationKey["새로 고침"]),
            target: "refresh",
          },
        },
      }}
      onInteraction={({ target }) => handleInteraction(target)}
    />
  );
}
